/**
 * --------------------------------------------------------------------------
 * Hive Component: Extensions/Registry.js
 * Copyright (c) 2005 - 2023 Paul Höcker / PHMG All rights reserved.
 * Licensed under GNU General Public License version 2 or later
 * --------------------------------------------------------------------------
 */

// noinspection JSUnusedGlobalSymbols

/**
 * Constants
 */

const NAME = 'Registry'
const VERSION = '1.0.0'

/**
 * Registry
 */
class Registry {

	#data;

	/**
	 * @return {string}
	 */
	static get NAME() {
		return NAME
	}

	/**
	 * @return {string}
	 */
	static get VERSION() {
		return VERSION
	}

	/**
	 * Registry constructor
	 * @param {{}} [data]
	 */
	constructor(data) {
		this.#data = {};

		if (data) this.load(data);
	}

	/**
	 *
	 * @param {{}|[]} data
	 * @returns {Registry}
	 */
	load(data) {
		if (!data) return this;

		if (Array.isArray(data)) data = Object.assign({}, data);

		Object.assign(this.#data, data);

		return this;
	}

	/**
	 *
	 * @param {string} path
	 * @param {*} [def]
	 * @returns {*|null}
	 */
	get(path, def) {
		if (!path.includes('.')) {
			return this.#get(path, this.#data, def);
		}

		let keys = path.split('.');
		let vkey = keys.pop();
		let obj = this.#data;
		for (let key of keys) {
			obj = this.#get(key, obj, null);
			if (obj === null) return def;
		}

		return this.#get(vkey, obj, def);
	}

	/**
	 *
	 * @param {string} key
	 * @param {{}} obj
	 * @param {*|null} [def]
	 * @returns {*|null}
	 */
	#get(key, obj, def) {
		return obj && obj[key] !== undefined ? obj[key] : def;
	}

	/**
	 *
	 * @param {string} path
	 * @param {*} value
	 * @returns {Registry}
	 */
	set(path, value) {
		if (!path.includes('.')) {
			this.#data[path] = value;

			return this;
		}

		let keys = path.split('.');
		let vkey = keys.pop();
		let obj = this.#data;
		for (let key of keys) {
			obj[key] = obj[key] || {};
			obj = obj[key];
		}

		obj[vkey] = value;

		return this;
	}

	/**
	 * Return a copy of the data
	 * @returns {{}}
	 */
	toData() {
		return Object.assign({}, this.#data);
	}

	/**
	 * Return the original data
	 * @returns {{}}
	 */
	getData() {
		return this.#data;
	}
}

export default Registry